module.exports = __webpack_public_path__ + "assets/img/title-cb9dcabf.png";